export enum EPreSelectedResource {
  Warning = "Warning",
  Removed = "Removed",
  OpenOderForm = "OpenOderForm",
  MoveOrder = "MoveOrder",
  ConflictOccurrence = "ConflictOccurrence",
  MeetingType = "MeetingType",
}
